import React from "react";
import { MessageCircle } from "lucide-react";
import { EISG } from "@/constants/testIds";

const WhatsAppButton = () => (
  <a
    data-testid={EISG.whatsappBtn}
    href="https://wa.me/27836274861?text=Bonjour%20EISG%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20vos%20programmes."
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white px-4 py-3 rounded-full shadow-2xl shadow-[#25D366]/30 transition-all hover:scale-105"
    aria-label="WhatsApp"
  >
    <MessageCircle size={18} />
    <span className="text-sm font-semibold tracking-wide">WhatsApp</span>
  </a>
);

export default WhatsAppButton;
